var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"exercise-preview-modal",attrs:{"specialModal":true,"buttons":[
    { name: _vm.ButtonConfirmationTxt, type: 'main', action: _vm.confirm },
    { name: 'Annuler', action: _vm.close }
  ]},on:{"close":_vm.close}},[(_vm.headerTxt)?_c('span',{staticClass:"header-txt"},[_vm._v(_vm._s(_vm.headerTxt))]):_vm._e(),_c('span',{staticClass:"span-modal"},[_vm._v(_vm._s(_vm.modalMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }